(() => {
  const normalizeText = (value) =>
    value
      .replace(/\bQAR\s*([0-9.]+),(\d{2})\b/g, (_, whole, decimals) =>
        `QAR ${whole.replace(/\./g, ',')}.${decimals}`
      )
      .replace(/\b([0-9.]+),(\d{2})\s*QAR\b/g, (_, whole, decimals) =>
        `QAR ${whole.replace(/\./g, ',')}.${decimals}`
      );

  const normalizeNode = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const normalized = normalizeText(node.nodeValue || '');
      if (normalized !== node.nodeValue) node.nodeValue = normalized;
    });
  };

  const start = () => {
    normalizeNode(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            const normalized = normalizeText(node.nodeValue || '');
            if (normalized !== node.nodeValue) node.nodeValue = normalized;
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            normalizeNode(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
